import React, {Component} from 'react';
import {Form, Input, Button, Alert} from 'antd';
import {randomColor} from 'randomcolor';
import * as srv from '../../services';

const FormItem = Form.Item;

class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            loading: false,
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                if (!this.props.account.user.id || this.props.account.user.id === 0) {
                    return;
                }

                this.setState({loading: true});

                if (!values.password1) {
                    delete values.password1;
                }

                values.projectId = 63;
                values.id = this.props.account.user.id;

                let data = await srv.postUpdateUser(values);

                if (data && data.status === 200) {
                    this.setState({loading: false, successText: 'Lưu thành công!', errorText: ''});

                    if (values.password1 && values.password2 && values.password1.length > 0 && values.password2.length > 0) {
                        window.alert('Thay đổi mật khẩu thành công!');

                        this.props.logout();
                    }
                } else {
                    this.setState({loading: false, successText: '', errorText: 'Có lỗi xảy ra vui lòng thử lại!'});
                }

            }
        });
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({confirmDirty: this.state.confirmDirty || !!value});
    }

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password1')) {
            callback('Mật khẩu và xác nhận mật khẩu không giống nhau!');
        } else {
            callback();
        }
    }

    checkConfirm = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['password2'], {force: true});
        }
        callback();
    }

    genNewColor = (event) => {
        this.props.form.setFieldsValue({
            color: randomColor()
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 6},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 14},
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };

        return (
            <Form
                style={{marginTop: '100px'}}
                onSubmit={this.handleSubmit}>

                <FormItem
                    {...formItemLayout}
                    label="Họ"
                >
                    {getFieldDecorator('firstname', {
                        rules: [{required: true, message: 'Họ không được để trống!', whitespace: true}],
                    })(
                        <Input/>
                    )}
                </FormItem>

                <FormItem
                    {...formItemLayout}
                    label="Tên"
                >
                    {getFieldDecorator('lastname', {
                        rules: [{required: true, message: 'Tên không được để trống!', whitespace: true}],
                    })(
                        <Input/>
                    )}
                </FormItem>

                <FormItem
                    {...formItemLayout}
                    label="E-mail"
                    hasFeedback
                >
                    {getFieldDecorator('mail', {
                        rules: [{
                            type: 'email', message: 'Email nhập vào không đúng!',
                        }, {
                            required: true, message: 'Email không được để trống!',
                        }],
                    })(
                        <Input/>
                    )}
                </FormItem>

                <FormItem
                    {...formItemLayout}
                    label="Mật khẩu"
                    hasFeedback
                >
                    {getFieldDecorator('password1', {
                        rules: [{
                            validator: this.checkConfirm,
                        }],
                    })(
                        <Input type="password"/>
                    )}
                </FormItem>
                {
                    this.props.form.getFieldValue('password1') && this.props.form.getFieldValue('password1').length > 0 ?
                        <FormItem
                            {...formItemLayout}
                            label="Xác nhận mật khẩu"
                            hasFeedback
                        >
                            {getFieldDecorator('password2', {
                                rules: [{
                                    required: true,
                                    message: 'Xin hãy xác nhận mật khẩu!',
                                }, {
                                    validator: this.checkPassword,
                                }],
                            })(
                                <Input type="password" onBlur={this.handleConfirmBlur}/>
                            )}
                        </FormItem>
                        : null
                }

                <FormItem
                    {...formItemLayout}
                    label="Màu sắc hiển thị"
                >
                    <Input.Group compact
                                 style={{
                                     display: 'inline-flex',
                                     float: 'left',
                                 }}>

                        {getFieldDecorator('color', {
                            rules: [{required: false}],
                        })(
                            <Input size="large"/>
                        )}

                        <Button size="large"
                                style={{
                                    color: '#fff',
                                    background: this.props.form.getFieldValue('color'),
                                    border: `1px solid ${this.props.form.getFieldValue('color')}`
                                }}
                                onClick={this.genNewColor}>
                            Gen new color
                        </Button>
                    </Input.Group>
                </FormItem>

                {
                    this.state.successText && this.state.successText.length > 0 ?
                        <FormItem {...tailFormItemLayout}>
                            <Alert message={this.state.successText} type="success" closable showIcon/>
                        </FormItem>
                        : null
                }

                {
                    this.state.errorText && this.state.errorText.length > 0 ?
                        <FormItem {...tailFormItemLayout}>
                            <Alert message={this.state.errorText} type="error" closable showIcon/>
                        </FormItem>
                        : null
                }

                <FormItem {...tailFormItemLayout}>
                    <Button
                        loading={this.state.loading}
                        style={{padding: '0 86px'}}
                        type="primary"
                        htmlType="submit">
                        Lưu
                    </Button>
                </FormItem>

            </Form>
        );
    }
}

export default Form.create({
    mapPropsToFields(props) {
        return {
            firstname: {
                value: props.account.user.firstname,
            },
            lastname: {
                value: props.account.user.lastname,
            },
            color: {
                value: props.account.user.color ? props.account.user.color : randomColor(),
            },
            mail: {
                value: props.account.user.mail ? props.account.user.mail : '',
            },
        };
    }
})(Setting);


// WEBPACK FOOTER //
// ./src/components/users/setting.js